/**
 * React Query hook for Matches API
 */

import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../helpers/apiClient.helper';
import { fetchMatches } from '../helpers/friendsApi';
import { STALE_TIME_MATCHES_MS } from '../constants/reactQuery.constants';

/**
 * Hook to fetch matches
 * @param matchIds - Optional array of match IDs to fetch (fetches all if not provided)
 * @param enabled - Whether the query should run (default: true)
 */
export const useMatchesQuery = (matchIds?: string[], enabled: boolean = true) => {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['matches', { ids: matchIds?.slice().sort() ?? [] }],
    queryFn: async () => {
      return fetchMatches(apiClient, matchIds);
    },
    enabled,
    staleTime: STALE_TIME_MATCHES_MS,
    gcTime: 15 * 60 * 1000, // Keep in cache for 15 minutes
  });
};
